export interface SocialShareLinks {
  facebook: string,
  twitter: string,
  linkedin: string,
  email: string,
}

export default function getSocialShareLinks(url: string, title: string = '', text: string = ''): SocialShareLinks {
  const encoded = encodeURI(url);

  return {
    facebook: `https://www.facebook.com/sharer.php?u=${encoded}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(`${title} ${text}`)}&url=${encoded}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encoded}`,
    email: `mailto:?subject=${`${encodeURIComponent(title)} | Dove.it`}&body=${encodeURI(url)}`,
  };
}
